import { render, staticRenderFns } from "./TwoFaCodeCard.vue?vue&type=template&id=a18b4ca4&scoped=true&"
import script from "./TwoFaCodeCard.vue?vue&type=script&lang=js&"
export * from "./TwoFaCodeCard.vue?vue&type=script&lang=js&"
import style0 from "./TwoFaCodeCard.vue?vue&type=style&index=0&id=a18b4ca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18b4ca4",
  null
  
)

export default component.exports